"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

exports.ManagerErrorCodes = ['UNEXPECTED_ERROR', 'ALL_CONNECTORS_INVALID'].reduce(function (accumulator, currentValue) {
  accumulator[currentValue] = currentValue;
  return accumulator;
}, {});
var unexpectedErrorMessage = 'Unexpected Error. Please file an issue on Github.';
var initialWeb3State = {
  account: undefined,
  connectorName: undefined,
  error: null,
  library: undefined,
  networkId: undefined
};

function reRendererReducer(state, action) {
  var _a;

  switch (action.type) {
    case 'RERENDER':
      return __assign({}, state, (_a = {}, _a[action.payload] = state[action.payload] + 1, _a));

    default:
      {
        var error = Error(unexpectedErrorMessage);
        console.error(error, state, action); // tslint:disable-line: no-console

        throw error;
      }
  }
}

function web3StateReducer(state, action) {
  switch (action.type) {
    case 'UPDATE_CONNECTOR_VALUES':
      {
        var _a = action.payload,
            connectorName = _a.connectorName,
            library = _a.library,
            networkId = _a.networkId,
            account = _a.account;
        return {
          connectorName: connectorName,
          library: library,
          networkId: networkId,
          account: account,
          error: null
        };
      }

    case 'UPDATE_NETWORK_ID':
      {
        var _b = action.payload,
            library = _b.library,
            networkId = _b.networkId;
        return __assign({}, state, {
          library: library,
          networkId: networkId,
          error: null
        });
      }

    case 'UPDATE_ACCOUNT':
      return __assign({}, state, {
        account: action.payload,
        error: null
      });

    case 'UPDATE_NETWORK_ID_AND_ACCOUNT':
      {
        var _c = action.payload,
            library = _c.library,
            networkId = _c.networkId,
            account = _c.account;
        return __assign({}, state, {
          library: library,
          networkId: networkId,
          account: account,
          error: null
        });
      }

    case 'UPDATE_ERROR':
      return __assign({}, state, {
        error: action.payload
      });

    case 'UPDATE_ERROR_WITH_NAME':
      {
        var _d = action.payload,
            error = _d.error,
            connectorName = _d.connectorName;
        return __assign({}, state, {
          error: error,
          connectorName: connectorName
        });
      }

    case 'RESET':
      return initialWeb3State;

    default:
      {
        var error = Error(unexpectedErrorMessage);
        console.error(error, state, action); // tslint:disable-line: no-console

        throw error;
      }
  }
}

function useWeb3Manager(connectors, libraryName, reRendererNames) {
  var _this = this; // keep track of web3 state


  var _a = react_1.useReducer(web3StateReducer, initialWeb3State),
      web3State = _a[0],
      dispatchWeb3State = _a[1];

  var web3Initialized = !!(web3State.account !== undefined && web3State.connectorName && !web3State.error && web3State.library && web3State.networkId); // TODO consider exposing this in context?
  // keep track of active connector

  var activeConnector = web3State.connectorName ? connectors[web3State.connectorName] : undefined; // function to set a connector

  function setConnector(connectorName, suppressAndThrowErrors) {
    if (suppressAndThrowErrors === void 0) {
      suppressAndThrowErrors = false;
    }

    return __awaiter(this, void 0, void 0, function () {
      var validConnectorNames, error, error, connector, library_1, networkIdPromise, accountPromise, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            validConnectorNames = Object.keys(connectors);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 5,, 6]);

            if (!validConnectorNames.includes(connectorName)) {
              error = Error("'" + connectorName + "' is not a valid name. Valid names are: " + validConnectorNames.join(', '));
              error.code = exports.ManagerErrorCodes.UNEXPECTED_ERROR;
              console.error(error); // tslint:disable-line: no-console

              throw error;
            }

            if (connectorName === web3State.connectorName) {
              error = Error("'" + connectorName + "' is already set.");
              error.code = exports.ManagerErrorCodes.UNEXPECTED_ERROR;
              console.error(error); // tslint:disable-line: no-console

              throw error;
            }

            connector = connectors[connectorName];
            return [4
            /*yield*/
            , connector.onActivation()];

          case 2:
            _a.sent();

            return [4
            /*yield*/
            , connector.getLibrary(libraryName)];

          case 3:
            library_1 = _a.sent();
            networkIdPromise = connector.getNetworkId(library_1);
            accountPromise = connector.getAccount(library_1);
            return [4
            /*yield*/
            , Promise.all([networkIdPromise, accountPromise]).then(function (_a) {
              var networkId = _a[0],
                  account = _a[1];
              dispatchWeb3State({
                payload: {
                  connectorName: connectorName,
                  library: library_1,
                  networkId: networkId,
                  account: account
                },
                type: 'UPDATE_CONNECTOR_VALUES'
              });
            })];

          case 4:
            _a.sent();

            return [3
            /*break*/
            , 6];

          case 5:
            error_1 = _a.sent();

            if (suppressAndThrowErrors) {
              throw error_1;
            } else {
              setError(error_1, connectorName);
            }

            return [3
            /*break*/
            , 6];

          case 6:
            return [2
            /*return*/
            ];
        }
      });
    });
  } // expose a wrapper to set the first valid connector in a list


  function setFirstValidConnector(connectorNames, suppressAndThrowErrors) {
    if (suppressAndThrowErrors === void 0) {
      suppressAndThrowErrors = true;
    }

    return __awaiter(this, void 0, void 0, function () {
      var _i, connectorNames_1, connectorName, error_2, error_3;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _i = 0, connectorNames_1 = connectorNames;
            _a.label = 1;

          case 1:
            if (!(_i < connectorNames_1.length)) return [3
            /*break*/
            , 6];
            connectorName = connectorNames_1[_i];
            _a.label = 2;

          case 2:
            _a.trys.push([2, 4,, 5]);

            return [4
            /*yield*/
            , setConnector(connectorName, true)];

          case 3:
            _a.sent();

            return [3
            /*break*/
            , 6];

          case 4:
            error_2 = _a.sent();

            if (connectorName === connectorNames[connectorNames.length - 1]) {
              error_3 = Error('Unable to set any valid connector.');
              error_3.code = exports.ManagerErrorCodes.ALL_CONNECTORS_INVALID;

              if (suppressAndThrowErrors) {
                throw error_3;
              } else {
                setError(error_3);
              }
            }

            return [3
            /*break*/
            , 5];

          case 5:
            _i++;
            return [3
            /*break*/
            , 1];

          case 6:
            return [2
            /*return*/
            ];
        }
      });
    });
  } // function to unset the current connector


  function unsetConnector() {
    dispatchWeb3State({
      type: 'RESET'
    });
  } // function to set the error state. consider adding a (global?) flag to clear state on error?


  function setError(error, connectorName) {
    if (connectorName) {
      dispatchWeb3State({
        type: 'UPDATE_ERROR_WITH_NAME',
        payload: {
          error: error,
          connectorName: connectorName
        }
      });
    } else {
      dispatchWeb3State({
        type: 'UPDATE_ERROR',
        payload: error
      });
    }
  } // ensure that connectors are cleaned up whenever they're changed


  react_1.useEffect(function () {
    if (activeConnector) {
      return function () {
        return activeConnector.onDeactivation();
      };
    }
  }, [activeConnector]); // change listeners

  var web3ReactSharedHandler = react_1.useCallback(function (networkId, account) {
    return __awaiter(_this, void 0, void 0, function () {
      var error, library, returnedNetworkId, error, error_4;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!activeConnector) return [3
            /*break*/
            , 1];
            error = Error(unexpectedErrorMessage);
            error.code = exports.ManagerErrorCodes.UNEXPECTED_ERROR;
            console.error(error); // tslint:disable-line: no-console

            setError(error);
            return [3
            /*break*/
            , 6];

          case 1:
            if (!(networkId === web3State.networkId)) return [3
            /*break*/
            , 2];

            if (account) {
              web3ReactUpdateAccountHandler(account);
            }

            return [3
            /*break*/
            , 6];

          case 2:
            _a.trys.push([2, 5,, 6]);

            return [4
            /*yield*/
            , activeConnector.getLibrary(libraryName, networkId) // we technically don't need to call this if we trust the connector is implemented in a particular way...
            // ...though this is required _if_ we only validate network IDs inside getNetworkId, which we kind of want
            ];

          case 3:
            library = _a.sent();
            return [4
            /*yield*/
            , activeConnector.getNetworkId(library) // also, we _could_ call .getAccount(), but that seems pretty redundant, so we just take it for granted...
            // ...that the new account is correct!
            // this indicates an error in the way the active connector's 'getLibrary' function is implemented
            ];

          case 4:
            returnedNetworkId = _a.sent(); // also, we _could_ call .getAccount(), but that seems pretty redundant, so we just take it for granted...
            // ...that the new account is correct!
            // this indicates an error in the way the active connector's 'getLibrary' function is implemented

            if (networkId !== returnedNetworkId) {
              error = Error(unexpectedErrorMessage);
              error.code = exports.ManagerErrorCodes.UNEXPECTED_ERROR;
              console.error(error); // tslint:disable-line: no-console

              setError(error);
            } else {
              if (account) {
                dispatchWeb3State({
                  type: 'UPDATE_NETWORK_ID_AND_ACCOUNT',
                  payload: {
                    library: library,
                    networkId: networkId,
                    account: account
                  }
                });
              } else {
                dispatchWeb3State({
                  type: 'UPDATE_NETWORK_ID',
                  payload: {
                    library: library,
                    networkId: networkId
                  }
                });
              }
            }

            return [3
            /*break*/
            , 6];

          case 5:
            error_4 = _a.sent();
            setError(error_4);
            return [3
            /*break*/
            , 6];

          case 6:
            return [2
            /*return*/
            ];
        }
      });
    });
  }, [activeConnector, web3State.networkId]);
  var web3ReactUpdateNetworkIdHandler = react_1.useCallback(function (networkId) {
    web3ReactSharedHandler(networkId);
  }, [web3ReactSharedHandler]); // this is pure, we don't need to worry about useCallback

  function web3ReactUpdateAccountHandler(account) {
    dispatchWeb3State({
      type: 'UPDATE_ACCOUNT',
      payload: account
    });
  }

  var web3ReactUpdateNetworkIdAndAccountHandler = react_1.useCallback(function (networkId, account) {
    web3ReactSharedHandler(networkId, account);
  }, [web3ReactSharedHandler]); // this is pure, we don't need to worry about useCallback

  function web3ReactErrorHandler(error) {
    setError(error);
  } // this is pure, we don't need to worry about useCallback


  function web3ReactResetHandler() {
    unsetConnector();
  }

  react_1.useEffect(function () {
    if (activeConnector) {
      activeConnector.on('_web3ReactUpdateNetworkId', web3ReactUpdateNetworkIdHandler);
      activeConnector.on('_web3ReactUpdateAccount', web3ReactUpdateAccountHandler);
      activeConnector.on('_web3ReactUpdateNetworkIdAndAccount', web3ReactUpdateNetworkIdAndAccountHandler);
      activeConnector.on('_web3ReactError', web3ReactErrorHandler);
      activeConnector.on('_web3ReactReset', web3ReactResetHandler);
      return function () {
        activeConnector.removeListener('_web3ReactUpdateNetworkId', web3ReactUpdateNetworkIdHandler);
        activeConnector.removeListener('_web3ReactUpdateAccount', web3ReactUpdateAccountHandler);
        activeConnector.removeListener('_web3ReactUpdateNetworkIdAndAccount', web3ReactUpdateNetworkIdAndAccountHandler);
        activeConnector.removeListener('_web3ReactError', web3ReactErrorHandler);
        activeConnector.removeListener('_web3ReactReset', web3ReactResetHandler);
      };
    }
  }, [activeConnector, web3ReactUpdateNetworkIdHandler, web3ReactUpdateNetworkIdAndAccountHandler]); // re renderers

  var _b = react_1.useReducer(reRendererReducer, reRendererNames.reduce(function (accumulator, currentValue) {
    accumulator[currentValue] = 0;
    return accumulator;
  }, {})),
      reRenderers = _b[0],
      dispatchReRender = _b[1];

  function forceReRender(reRenderer) {
    var validReRendererNames = Object.keys(reRenderers);

    if (!validReRendererNames.includes(reRenderer)) {
      var error = Error("'" + reRenderer + "' is not a valid name. Valid values are: " + validReRendererNames.join(', '));
      error.code = exports.ManagerErrorCodes.UNEXPECTED_ERROR;
      console.error(error); // tslint:disable-line: no-console

      setError(error);
    }

    dispatchReRender({
      type: 'RERENDER',
      payload: reRenderer
    });
  }

  return {
    web3Initialized: web3Initialized,
    web3State: web3State,
    connector: activeConnector,
    setConnector: setConnector,
    setFirstValidConnector: setFirstValidConnector,
    unsetConnector: unsetConnector,
    setError: setError,
    reRenderers: reRenderers,
    forceReRender: forceReRender
  };
}

exports.default = useWeb3Manager;